export default "__VITE_ASSET__QbmRZKXd__"